import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const PrintedHoodie = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.tops.PrintedHoodie.itemName}
      name={AW23.tops.PrintedHoodie.itemName}
      price={AW23.tops.PrintedHoodie.itemPrice}
      fabric={AW23.tops.PrintedHoodie.itemFabric}
      src={AW23.tops.PrintedHoodie.sizeChart}
      divId={AW23.tops.PrintedHoodie.shopifyDivId}
      mainId={AW23.tops.PrintedHoodie.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.tops.PrintedHoodie.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.tops.PrintedHoodie.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default PrintedHoodie;
